export enum CountryCode {
  GB = 'GB',
  US = 'US',
  CA = 'CA',
  SE = 'SE',
  NL = 'NL',
}
